<miq-stepper #stepper>
  <cdk-step>
    <miq-change-tags></miq-change-tags>
  </cdk-step>
  <cdk-step>
    <div class="loader-container">
      <div class="loading">
        <mat-progress-spinner diameter="30" mode="determinate" [value]="loaderValue"> </mat-progress-spinner>
        <span l10nTranslate>recordsClipboard.updating</span>
      </div>
      <div class="second-message" l10nTranslate>shared.takingFewMinutes</div>
    </div>
  </cdk-step>
  <cdk-step>
    <div class="finalized-container">
      <div class="title" [ngClass]="{ error: thereAreErrors, success: !thereAreErrors }" l10nTranslate>
        {{ thereAreErrors ? 'shared.error' : 'shared.success' }}
      </div>
      <div *ngIf="catastrophicFailure; else showMessage" class="errorinfo">
        <span l10nTranslate>recordsClipboard.errorUpdatingTags</span>
      </div>
      <ng-template #showMessage>
        <div *ngIf="!thereAreErrors" l10nTranslate>recordsClipboard.recordsUpdated</div>
        <div *ngIf="thereAreErrors">
          <div>
            <span l10nTranslate>recordsClipboard.tagsNotUpdated</span>
            <miq-goes-to-record
              *ngFor="let id of changeTagService.recordsWithErrors; last as isLast"
              [type]="changeTagService.entity"
              [id]="id"
              >{{ id }}{{ !isLast ? ', ' : '' }}
            </miq-goes-to-record>
          </div>
        </div>
      </ng-template>
    </div>
    <div class="confirm-label" mat-dialog-close l10nTranslate>shared.okGotIt</div>
  </cdk-step>
</miq-stepper>
